import React, { useState } from "react";
import {
  CheckboxWithLabel,
  FileWithLabel,
  SimpleDialog,
  memoWithOpen
} from "../../components";
import { FunctionProps } from "./props";
import { Grid } from "@mui/material";
import { DXFModelFilter, lasFileFilter } from "../../file-extensions";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { deleteAsset } from "../../redux/assets-slice";
import { useTaskQueue } from "../../hooks";
import { useAssetTools } from "../../utilities";

export const InterpolateDXF = memoWithOpen((props: FunctionProps) => {
  const {assets, open, onClose} = props;

  const dispatch = useDispatch();
  const {addRunningTask} = useTaskQueue();
  const {addAssetPaths} = useAssetTools();
  const {t} = useTranslation();

  const [outputPath, setOutputPath] = useState(null);
  const [demPath, setDemPath] = useState(null);
  const [importResult, setImportResult] = useState(true);

  // TODO: actually handle multiple inputs (sent multiple exe commands to processing queue)
  const asset = assets ? assets[0] : undefined;

  const handleSubmit = () => {
    const pythonName = "interpolate_dxf";

    let commands = [
      "-p", pythonName,
      "--input_path", asset.path,
      "--output_path", outputPath,
      "--dem_path", demPath
    ];

    const onFinish = async () => {
      if (!importResult) return;

      // Remove old dxf
      dispatch(deleteAsset(asset.id));

      // Add new interpolated dxf
      await addAssetPaths([outputPath], asset.folderID);
    };

    onClose();
    addRunningTask(commands, onFinish);
  };

  const canSubmit = outputPath && demPath;

  return (
    <React.Fragment>
      <SimpleDialog
        open={open}
        onClose={onClose}
        onSubmit={handleSubmit}
        canSubmit={canSubmit}
        title={t('functions.interpolate_dxf.title')}
        button={t('buttons.submit')}
      >
        <Grid container spacing={2}>

          {/** Input DEM */}
          <Grid item xs={6}>
            <FileWithLabel
              title={t('functions.interpolate_dxf.input_las')}
              label={t('functions.interpolate_dxf.input_las_description')}
              filter={lasFileFilter}
              value={demPath}
              onChange={setDemPath}
            />
          </Grid>

          {/** Output DXF */}
          <Grid item xs={6}>
            <FileWithLabel
              title={t('functions.interpolate_dxf.output_dxf')}
              label={t('functions.interpolate_dxf.output_dxf_description')}
              filter={DXFModelFilter}
              value={outputPath}
              onChange={setOutputPath}
              saveFile
            />
          </Grid>

          {/** Import results */}
          <Grid item xs={6}>
            <CheckboxWithLabel
              title={t('functions.import_results')}
              label={t('functions.interpolate_dxf.import_result_description')}
              value={importResult}
              onChange={setImportResult}
            />
          </Grid>

        </Grid>
      </SimpleDialog>
    </React.Fragment>
  );
});
